
<script>
import { image } from 'helper/assets'
import { combineClassLists } from 'helper/render'

export default {
  name: 'Logo',
  functional: true,
  props: {
    label: {
      type: String,
      default: 'Company'
    }, 
    img: {
      type: String,
      default: 'logo.png'
    },
    height: {
      type: [Number, String],
      default: 40
    }
  },
  render(h, context) {
    return h('img', {
      attrs: {
        src: image({ name: context.props.img }),
        height: `${context.props.height}`
      },
      class: combineClassLists({ 
        classList: { Logo: true },
        context
      }),
      domProps: {
        alt: (`${context.props.label} logo`).trim()
      }
    })
  }
}
</script>
